import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🔁", key: "constantly" },
  { emoji: "🍂", key: "seasonally" },
  { emoji: "📅", key: "lifeEvents" },
  { emoji: "🐢", key: "rarely" },
]

export default function HomeUpdateFrequencyPage() {
  return (
    <RadioCardListPage translationKey="homeUpdateFrequency" options={OPTIONS} />
  )
}
